var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D5A150"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD712C"
    },
    d: "M415.237,55.557c34.771,43.71,55.556,99.043,55.556,159.236c0,141.385-114.615,256-256,256 c-60.193,0-115.527-20.785-159.237-55.556C102.456,474.194,174.808,512,256,512c141.385,0,256-114.615,256-256 C512,174.809,474.194,102.456,415.237,55.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M139.553,145.28c-5.273,0-10.546-2.012-14.569-6.035c-22.091-22.091-22.091-58.037,0-80.13 c10.702-10.702,24.929-16.595,40.065-16.595c15.135,0,29.363,5.894,40.065,16.595c8.046,8.047,8.046,21.092,0,29.139 c-8.048,8.045-21.093,8.046-29.139,0c-2.919-2.919-6.799-4.527-10.926-4.527c-4.127,0-8.008,1.608-10.926,4.527 c-6.026,6.026-6.026,15.829,0,21.853c8.047,8.047,8.047,21.092,0,29.138C150.099,143.269,144.826,145.28,139.553,145.28z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674230"
    },
    cx: 165.045,
    cy: 99.186,
    r: 36.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A5436"
    },
    d: "M129.154,95.733c-0.013,0.139-0.025,0.277-0.037,0.416c-0.983,11.929,8.817,21.985,20.779,21.551 c0.792-0.029,1.591-0.083,2.393-0.164c16.973-1.712,30.582-15.435,32.172-32.42c0.013-0.139,0.025-0.277,0.036-0.415 c0.983-11.928-8.817-21.985-20.779-21.551c-0.792,0.029-1.591,0.083-2.393,0.164C144.353,65.025,130.744,78.748,129.154,95.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M57.139,310.109c-5.273,0-10.546-2.012-14.569-6.035c-22.091-22.091-22.091-58.037,0-80.13 C53.272,213.243,67.5,207.35,82.635,207.35s29.363,5.894,40.065,16.595c8.046,8.047,8.046,21.092,0,29.139 c-8.048,8.045-21.093,8.046-29.139,0c-2.919-2.919-6.799-4.527-10.926-4.527c-4.127,0-8.008,1.608-10.926,4.527 c-6.026,6.026-6.026,15.829,0,21.853c8.047,8.047,8.047,21.092,0,29.138C67.685,308.098,62.411,310.109,57.139,310.109z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674230"
    },
    cx: 82.631,
    cy: 264.015,
    r: 36.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A5436"
    },
    d: "M46.739,260.562c-0.013,0.139-0.025,0.277-0.037,0.416c-0.983,11.93,8.817,21.985,20.779,21.551 c0.792-0.029,1.591-0.083,2.393-0.164c16.973-1.712,30.582-15.435,32.172-32.42c0.013-0.139,0.025-0.277,0.036-0.415 c0.983-11.928-8.817-21.985-20.779-21.551c-0.792,0.029-1.591,0.083-2.393,0.164C61.939,229.854,48.33,243.577,46.739,260.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M129.252,413.127c-5.273,0-10.546-2.012-14.569-6.035c-22.091-22.091-22.091-58.037,0-80.13 c10.702-10.702,24.929-16.595,40.065-16.595s29.363,5.894,40.065,16.595c8.046,8.047,8.046,21.092,0,29.139 c-8.048,8.045-21.093,8.046-29.139,0c-2.918-2.919-6.799-4.527-10.926-4.527s-8.008,1.608-10.926,4.527 c-6.026,6.026-6.026,15.829,0,21.853c8.047,8.047,8.047,21.092,0,29.138C139.798,411.116,134.524,413.127,129.252,413.127z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674230"
    },
    cx: 154.743,
    cy: 367.033,
    r: 36.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A5436"
    },
    d: "M118.852,363.58c-0.013,0.139-0.025,0.277-0.037,0.416c-0.983,11.929,8.817,21.985,20.779,21.551 c0.792-0.029,1.591-0.083,2.393-0.164c16.973-1.712,30.582-15.435,32.172-32.42c0.013-0.139,0.025-0.277,0.036-0.415 c0.983-11.928-8.817-21.984-20.779-21.551c-0.792,0.029-1.591,0.083-2.393,0.164C134.051,332.872,120.443,346.595,118.852,363.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M242.572,485.24c-5.273,0-10.546-2.012-14.569-6.035c-22.091-22.091-22.091-58.037,0-80.13 c10.702-10.702,24.929-16.595,40.065-16.595c15.135,0,29.363,5.894,40.065,16.595c8.046,8.047,8.046,21.092,0,29.139 c-8.048,8.045-21.093,8.046-29.139,0c-2.919-2.919-6.799-4.527-10.926-4.527c-4.127,0-8.008,1.608-10.926,4.527 c-6.026,6.026-6.026,15.829,0,21.853c8.047,8.047,8.047,21.092,0,29.138C253.118,483.229,247.844,485.24,242.572,485.24z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674230"
    },
    cx: 268.063,
    cy: 439.146,
    r: 36.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A5436"
    },
    d: "M232.172,435.692c-0.013,0.139-0.025,0.277-0.037,0.416c-0.983,11.929,8.817,21.985,20.779,21.551 c0.792-0.029,1.591-0.083,2.393-0.164c16.973-1.712,30.582-15.435,32.172-32.42c0.013-0.139,0.025-0.277,0.036-0.415 c0.983-11.928-8.817-21.984-20.779-21.551c-0.792,0.029-1.591,0.083-2.393,0.164C247.371,404.985,233.762,418.708,232.172,435.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M263.175,196.929c-5.273,0-10.546-2.012-14.569-6.035c-22.091-22.091-22.091-58.037,0-80.13 c10.702-10.702,24.929-16.595,40.065-16.595s29.363,5.894,40.065,16.595c8.046,8.047,8.046,21.092,0,29.139 c-8.048,8.045-21.093,8.046-29.139,0c-2.919-2.919-6.799-4.527-10.926-4.527s-8.008,1.608-10.926,4.527 c-6.026,6.026-6.026,15.829,0,21.853c8.047,8.047,8.047,21.092,0,29.138C273.721,194.918,268.448,196.929,263.175,196.929z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674230"
    },
    cx: 288.667,
    cy: 150.829,
    r: 36.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A5436"
    },
    d: "M252.776,147.382c-0.013,0.139-0.025,0.277-0.037,0.416c-0.983,11.929,8.817,21.985,20.779,21.551 c0.792-0.029,1.591-0.083,2.393-0.164c16.973-1.712,30.582-15.435,32.172-32.42c0.013-0.139,0.025-0.277,0.036-0.415 c0.983-11.928-8.817-21.985-20.779-21.551c-0.792,0.029-1.591,0.083-2.393,0.164C267.975,116.674,254.366,130.397,252.776,147.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M386.797,382.222c-5.273,0-10.546-2.012-14.569-6.035c-22.091-22.091-22.091-58.037,0-80.13 c10.702-10.702,24.929-16.595,40.065-16.595s29.363,5.894,40.065,16.595c8.046,8.047,8.046,21.092,0,29.139 c-8.048,8.045-21.093,8.046-29.139,0c-2.919-2.919-6.799-4.527-10.926-4.527c-4.127,0-8.008,1.608-10.926,4.527 c-6.026,6.026-6.026,15.829,0,21.853c8.047,8.047,8.047,21.092,0,29.138C397.343,380.211,392.069,382.222,386.797,382.222z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674230"
    },
    cx: 412.289,
    cy: 336.127,
    r: 36.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A5436"
    },
    d: "M376.397,332.674c-0.013,0.139-0.025,0.277-0.036,0.416c-0.983,11.929,8.817,21.985,20.779,21.551 c0.792-0.029,1.591-0.083,2.393-0.164c16.973-1.712,30.582-15.435,32.172-32.42c0.013-0.139,0.025-0.277,0.036-0.415 c0.983-11.928-8.817-21.984-20.779-21.551c-0.792,0.029-1.591,0.083-2.393,0.164C391.597,301.967,377.988,315.69,376.397,332.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M376.495,186.488c-5.273,0-10.546-2.012-14.569-6.035c-22.091-22.091-22.091-58.037,0-80.13 c10.702-10.702,24.929-16.595,40.065-16.595s29.363,5.894,40.065,16.595c8.046,8.047,8.046,21.092,0,29.139 c-8.048,8.045-21.093,8.046-29.139,0c-2.919-2.918-6.799-4.527-10.926-4.527s-8.008,1.608-10.926,4.527 c-6.026,6.026-6.026,15.829,0,21.853c8.047,8.047,8.047,21.092,0,29.138C387.041,184.477,381.768,186.488,376.495,186.488z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674230"
    },
    cx: 401.987,
    cy: 140.393,
    r: 36.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A5436"
    },
    d: "M366.095,136.94c-0.013,0.139-0.025,0.277-0.036,0.416c-0.983,11.93,8.817,21.985,20.779,21.551 c0.792-0.029,1.591-0.083,2.393-0.164c16.973-1.712,30.582-15.435,32.172-32.42c0.013-0.139,0.025-0.277,0.036-0.415 c0.983-11.928-8.817-21.985-20.779-21.551c-0.792,0.029-1.591,0.083-2.393,0.164C381.295,106.232,367.686,119.955,366.095,136.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M221.968,310.109c-5.273,0-10.546-2.012-14.569-6.035c-22.091-22.091-22.091-58.037,0-80.13 c10.702-10.702,24.929-16.595,40.065-16.595s29.363,5.894,40.065,16.595c8.046,8.047,8.046,21.092,0,29.139 c-8.048,8.045-21.093,8.046-29.139,0c-2.918-2.919-6.799-4.527-10.926-4.527s-8.008,1.608-10.926,4.527 c-6.026,6.026-6.026,15.829,0,21.853c8.047,8.047,8.047,21.092,0,29.138C232.514,308.098,227.24,310.109,221.968,310.109z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674230"
    },
    cx: 247.46,
    cy: 264.015,
    r: 36.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A5436"
    },
    d: "M211.568,260.562c-0.013,0.139-0.025,0.277-0.037,0.416c-0.983,11.93,8.817,21.985,20.779,21.551 c0.792-0.029,1.591-0.083,2.393-0.164c16.973-1.712,30.582-15.435,32.172-32.42c0.013-0.139,0.025-0.277,0.036-0.415 c0.983-11.928-8.817-21.985-20.779-21.551c-0.792,0.029-1.591,0.083-2.393,0.164C226.768,229.854,213.159,243.577,211.568,260.562z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 129.803,
    cy: 294.632,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 181.312,
    cy: 294.632,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 155.557,
    cy: 248.274,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 62.841,
    cy: 340.99,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 165.859,
    cy: 454.31,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 196.765,
    cy: 413.103,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 248.274,
    cy: 351.292,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 330.688,
    cy: 320.386,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 310.085,
    cy: 340.99,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 340.99,
    cy: 371.895,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 340.99,
    cy: 433.706,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 454.31,
    cy: 217.368,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 423.404,
    cy: 423.404,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 268.877,
    cy: 31.936,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 83.445,
    cy: 124.652,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 42.237,
    cy: 186.463,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 160.708,
    cy: 201.915,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 191.614,
    cy: 186.463,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 160.708,
    cy: 171.01,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 304.934,
    cy: 248.274,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 237.972,
    cy: 93.746,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 335.839,
    cy: 186.463,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 351.292,
    cy: 232.821,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 382.197,
    cy: 232.821,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 382.197,
    cy: 263.726,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 325.537,
    cy: 78.294,
    r: 7.726
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD712C"
    },
    cx: 356.443,
    cy: 62.841,
    r: 7.726
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.fec624db4035706bd9942dc72e856790.svg";
export { ForwardRef as ReactComponent };